module.exports = __webpack_public_path__ + "img/obs_camera_river.9667c0d9.svg";